module.exports = __webpack_public_path__ + "static/media/icon_seal.74d2070c.svg";